import { lsSelectedCompany } from "../constans/auth";


export const currentIdCompany = () => {
    const data = localStorage.getItem(lsSelectedCompany);
    if (data) {
        try {
            return JSON.parse(data).id_company;
        } catch {
            return null;
        }
    }
    return null;
}